import { CONTACT_EMAIL, LEGAL_UPDATED, type LegalSection } from '../lib/legal'
import { LegalFooter } from './LegalFooter'

type Props = {
  title: string
  sections: LegalSection[]
  onBack: () => void
  onPrivacy: () => void
  onTerms: () => void
}

export function LegalPage({ title, sections, onBack, onPrivacy, onTerms }: Props) {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center justify-between gap-3">
        <button type="button" className="ghost px-3" onClick={onBack}>
          Back
        </button>
        <p className="text-[11px] text-foam-faint">Updated {LEGAL_UPDATED}</p>
      </header>
      <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
      {sections.map((section) => (
        <article key={section.heading} className="card space-y-2">
          <h2 className="text-base font-bold text-whiskey-light">{section.heading}</h2>
          {section.body.map((paragraph) => (
            <p key={paragraph} className="text-sm leading-relaxed text-foam-muted">
              {paragraph}
            </p>
          ))}
        </article>
      ))}
      <article className="card space-y-2">
        <h2 className="text-base font-bold text-whiskey-light">Contact</h2>
        <p className="text-sm leading-relaxed text-foam-muted">
          Questions about this app:{' '}
          <a
            className="text-whiskey-light underline-offset-2 hover:underline"
            href={`mailto:${CONTACT_EMAIL}`}
          >
            {CONTACT_EMAIL}
          </a>
        </p>
      </article>
      <LegalFooter onPrivacy={onPrivacy} onTerms={onTerms} />
    </section>
  )
}
